const ITEMS = [
  "Grant Writing", "Strategic Planning", "Fundraising", "Board Development",
  "Program Design", "501(c)(3) Formation", "Capacity Building", "Organizational Development",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee" className="bg-navy py-8 md:py-10 overflow-hidden border-y border-[hsl(var(--gold)/0.25)]">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl md:text-5xl font-light text-[hsl(var(--background))] px-8">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[hsl(var(--gold))]" />
          </span>
        ))}
      </div>
    </section>
  );
};
